import React from 'react';
import client1 from '../../assets/img/clients/client1.png';
import client2 from '../../assets/img/clients/client2.png';
import client3 from '../../assets/img/clients/client3.png';
import client4 from '../../assets/img/clients/client4.png';
import client5 from '../../assets/img/clients/client5.png';
import client6 from '../../assets/img/clients/client6.png';
import client7 from '../../assets/img/clients/client7.png';



const ClientsSection = () => {
  const clientLogos = [client1, client2, client3, client4, client5, client6, client7];

  return (
    <section className="clients-section">
      <h2>
        <span className="text-primary">Our Happy</span> Clients
      </h2>

      <div className="clients-logos-marquee">
        <div className="clients-logos-track">
          {[...Array(4)].map((_, setIndex) => (
            <React.Fragment key={setIndex}>
              {clientLogos.map((logo, i) => (
                <div className="client-logo" key={`client-${setIndex}-${i}`}>
                  <img src={logo.src || logo} alt={`Client ${i + 1}`} />
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
